import React from 'react';
import PropTypes from 'prop-types';

export default function withConfig(Component) {
  Component.contextTypes = Component.contextTypes || {};
  Component.contextTypes.config = PropTypes.object.isRequired;
  return Component;
}



// WEBPACK FOOTER //
// ./spa/Components/Context/withConfig.jsx